module.exports = __webpack_public_path__ + "static/media/Maskan.0973d2da.svg";